import React from "react";
import { Container, Grid, Skeleton } from "@mui/material";

function ViewClaimShimmerEffect() {
  return (
    <Container style={{ marginTop: "30px" }} maxWidth={"xl"}>
      <Skeleton
        variant="rect"
        width={"100%"}
        height={60}
        // style={{ marginTop: "20px" }}
      />
      <Skeleton
        variant="rect"
        width={"100%"}
        height={260}
        style={{ marginTop: "20px" }}
      />
      <Skeleton
        variant="rect"
        width={"100%"}
        height={60}
        style={{ marginTop: "20px" }}
      />
      <Skeleton
        variant="rect"
        width={"100%"}
        height={600}
        style={{ marginTop: "20px" }}
      />
      <Grid
        item
        style={{
          display: "flex",
          gap: "20px",
          flexDirection: "column",
          width: "70vw",
        }}
      ></Grid>
    </Container>
  );
}

export default ViewClaimShimmerEffect;
